module.exports = __webpack_public_path__ + "asset/pharos--d22b9c.svg";